import { EntityType } from '@frontend/common';
import { DeceasedClient } from '@frontend/deceased/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useDeceased:request': CustomEvent<string>;
    }
}

const REQUEST_DECEASED_EVENT = 'useDeceased:request';
const STORAGE_KEY = 'DECEASED_REQ';

export function deceasedRequest(deceasedId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_DECEASED_EVENT, { detail: deceasedId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function DeceasedResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_DECEASED_EVENT, EntityType.DECEASED, (ids) => DeceasedClient.resolveDeceaseds(ids), props.dispatch);
    return <></>;
}
